import React from "react";
import Emp_Files_Page from "./Emp_Files_Page";

// Thin wrapper — page rendering is identical to Emp_Form16_Files, only
// the `kind` prop differs so the shared component talks to the healthcard
// backend table + folder.
export default function Emp_Healthcard_Files({ navSize }) {
    return <Emp_Files_Page navSize={navSize} kind="healthcard" />;
}
